module.exports = __webpack_public_path__ + "static/media/familyPortrait91.c41515c2.png";